import React from 'react';

import {HeadSEO} from 'src/components/head-seo/head-seo.react-component';

import {DevHubPageBody} from './dev-hub-page-body.react-component';

export function DevHubPageFeature({children}: {children?: React.ReactNode}) {
    return (
        <>
            <HeadSEO canonicalUrl={`${process.env.NEXT_PUBLIC_MONOLITH_URL}/devhub`} />
            <DevHubPageBody>{children}</DevHubPageBody>
        </>
    );
}
